import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { ConfigService } from '../config.service';

/**
 * Keeps the site-level forms page behind the `form_tasks` feature flag.
 * With the flag off the user is sent to the root.
 */
export const formTasksRouteGuard: CanActivateFn = async () => {
  // inject before the first await, the injection context ends there
  const config = inject(ConfigService);
  const router = inject(Router);
  // guards run before resolvers, so make sure the api config (and its feature flags) is loaded
  await config.loadApiConfig();

  return config.isFeatureEnabled('form_tasks') || router.parseUrl('/');
};
